const SET_REDIRECT_URL = 'SET_REDIRECT_URL';

export default {
    SET_REDIRECT_URL,
};
